import { useTonWallet, useTonConnectUI } from '@tonconnect/ui-react'
import { useNavigate } from 'react-router-dom'
import { WalletMinimal } from 'lucide-react'
import { BalanceChip, WalletChip } from '../ui'
import { haptics } from '../../lib/haptics'
import type { BalanceInfo } from '../../lib/api'

interface Props {
  balance: BalanceInfo | null
}

export default function Header({ balance }: Props) {
  const wallet = useTonWallet()
  const [tonConnectUI] = useTonConnectUI()
  const navigate = useNavigate()

  return (
    <header
      className="fixed top-0 left-0 right-0 z-40 flex items-center justify-between px-sp-4 shrink-0"
      style={{
        height: 'var(--header-height)',
        paddingTop: 'var(--content-safe-top)',
        backgroundColor: 'var(--tg-theme-bg-color)',
        borderBottom: 'none',
      }}
    >
      {wallet ? (
        <BalanceChip balance={balance} />
      ) : (
        <button
          onClick={() => { haptics.impact('light'); navigate('/') }}
          className="flex items-center active:opacity-70 transition-opacity"
          aria-label="Home"
        >
          <img src="/imago_logo.png" alt="IMAGO" width={52} height={52} draggable={false} />
        </button>
      )}

      {wallet ? (
        <WalletChip />
      ) : (
        <button
          onClick={() => {
            haptics.impact('light')
            tonConnectUI.openModal()
          }}
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-full min-h-[32px] active:opacity-70 transition-opacity"
          style={{ backgroundColor: 'var(--tg-theme-button-color)', color: 'var(--tg-theme-button-text-color)' }}
        >
          <WalletMinimal size={13} strokeWidth={2} className="shrink-0" />
          <span className="text-[13px] font-medium">Connect Wallet</span>
        </button>
      )}
    </header>
  )
}
